module.exports = "/_next/static/images/SafariEnableMediaRecorder2-1b204dbe2c9392cdc41581e8e9e55e2d.png";